// extracted by mini-css-extract-plugin
export default {"AwsConsole":"AwsConsole_AwsConsole__HCX46","AwsLinks":"AwsConsole_AwsLinks__0TbR4","LinkItem":"AwsConsole_LinkItem__dDu3d","AwsLinkProgress":"AwsConsole_AwsLinkProgress__3x6dU"};